import React from 'react';

import { Col, Info, Row } from 'redpoints-front-components/index';
import { PriorityTag } from 'redpoints-front-common/components';

import rpfdate from 'redpoints-front-date';

import { translate } from './../../../helpers/languageHelper';

const FacilitatorValidationContentLinkInfo = ({ linkInfo }) => {
  const {
    assetName,
    creationDate,
    infringementVerifiedDate,
    priority,
    url,
  } = linkInfo;

  return (
    <div className="facilitator-validation-content-link-info">
      <Row gutter={16}>
        <Col xs={24} lg={20}>
          <Info
            label={translate(
              'tasks.facilitatorValidation.content.linkInfo.detectionLinkLabel'
            )}
            value={
              <a href={url} target="_blank" rel="noopener noreferrer">
                {url}
              </a>
            }
          />
        </Col>
        <Col xs={24} lg={4} className="priority-tag">
          <PriorityTag priority={priority} />
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} lg={8}>
          <Info
            label={translate(
              'tasks.facilitatorValidation.content.linkInfo.assetNameLabel'
            )}
            value={assetName}
          />
        </Col>
        <Col xs={24} lg={8}>
          <Info
            label={translate(
              'tasks.facilitatorValidation.content.linkInfo.linkCreationDateLabel'
            )}
            value={rpfdate(creationDate).format(rpfdate.MASKS.DATETIME)}
          />
        </Col>
        <Col xs={24} lg={8}>
          <Info
            label={translate(
              'tasks.facilitatorValidation.content.linkInfo.infringementVerifiedDateLabel'
            )}
            value={rpfdate(infringementVerifiedDate).format(
              rpfdate.MASKS.DATETIME
            )}
          />
        </Col>
      </Row>
    </div>
  );
};

export default FacilitatorValidationContentLinkInfo;
